enum MixPanelKeys {
  GET_QUOTE_PUBLIC_OPENED = 'Get Quote Public Opened',
  AUTHENTICATION_PAGE_VIEWED = 'Authentication page viewed',
  CARRIER_REGISTERED = 'Carrier Registered',
  LOGGED_IN = 'Logged in',
  OTP_CONFIRMED = 'OTP Confirmed',
  COMPANY_COUNTRY_SELECTED = 'Carrier company country selected',
  USER_AGREEMENTS_COMPLETED = 'User agreements completed',
  ACTIVE_JOBS_VIEWED = 'Active jobs viewed',
  PAST_JOBS_VIEWED = 'Past jobs viewed',
  POD_UPLOAD_INITIALIZED = 'POD upload initialized',
  DOCUMENT_UPLOADED = 'Document uploaded',
  CARRIER_COMPLETED_DOCUMENT_UPLOAD = 'Carrier completed document upload',
  ADD_INVOICE = 'Carrier viewed add invoice section on my payments tab',
  MY_INVOICES = 'Carrier viewed my invoice section on my payments tab',
  CARRIER_PICKED_COST = 'Carrier picked cost',
  CARRIER_CLICKED_ADD_INVOICE = 'Carrier clicked add invoice button',
  CARRIER_UPLOADED_INVOICE = 'Carrier uploaded invoice',
}

export default MixPanelKeys
